import {cardReaderTypes} from "./type";
import {BaseReducer} from "../../reducers/base";

const types = cardReaderTypes;

const initialState = {
    datas: [],
    data: {},
    isLoading: false,
    success: false,
    msg: {},
};

const cardReaderReducer = (state = initialState, action) => {
    const baseClass = new BaseReducer(types, state, action);

    return baseClass.baseReducer();
};

export default cardReaderReducer;
